<template>
	<div class style="width:100%;" v-loading="loadingPicSign  || loadings.upload">
		<a href="javascript:;" class="file" v-show="!isDisabled">
			<span class="el-icon-upload"></span>
			<input type="file" name="file" @change="selectFile" multiple="multiple" />
		</a>
		<div class="row">
			<div class="col-md-3 picture-card mt-3" v-for="(v,index) in value" :key="index">
				<el-tooltip placement="left-start">
					<div slot="content">
						<img :src="v+'?x-oss-process=style/thumb'" class="img-thumbnail img-tooltip" />
					</div>
					<img :src="v" class="img-fluid" />
				</el-tooltip>
				<div class="op-btns">
					<el-button icon="el-icon-delete" @click="handleRemovePic(index)" circle></el-button>
					<el-button
						icon="el-icon-d-arrow-left"
						@click="handlerReOrder(index,-1)"
						circle
						v-if="index!=0"
					></el-button>
					<el-button
						icon="el-icon-d-arrow-right"
						@click="handlerReOrder(index,1)"
						circle
						v-if="index!=value.length-1"
					></el-button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapState, mapGetters, mapMutations } from "vuex";
const OSS = require("ali-oss");
const client = new OSS({
	region: "oss-accelerate",
	// accessKeyId: "LTAIxmyq7VvD5YTb",//lesmo
	// accessKeySecret: "nthzLxzYEplYKOYuWaNrgVqvdBIiTw",
	accessKeyId: "LTAIrJCiyO81cehb", //anon
	accessKeySecret: "9wL8oWTILVkvMkGmJkzDRfPfMi28mV",
	bucket: "unik",
});

const url_replace = [
	'unik.oss-accelerate.aliyuncs.com',
	'unikpics.anontraveler.com'
];

const MAX_PICS_COUNT = 10;
export default {
	data() {
		return {
			id: "",
			loading: false,
			picList: [],
			loadings: {
				upload: false,
			},
			timeountHandler: null,
			uploadCounter: 0,
		};
	},
	props: {
		dataModelName: {
			type: String,
			default: "User",
		},
		value: {
			type: Array,
			default: function() {
				return [];
			},
		},
		fieldInfo: Object,
		recordId: {
			type: String,
			default: "",
		},
		allowedExt: {
			type: Array,
			default: () => {
				return ["image/png", "image/jpeg"];
			},
		},
	},
	computed: {
		...mapState(["picSign", "loadingPicSign"]),

		isDisabled() {
			return this.myValue.length > MAX_PICS_COUNT;
		},
		myValue: {
			get: function() {
				return this.value;
			},
			set: function(newValue) {
				this.$emit("input", newValue);
				this.$emit("change", newValue);
			},
		},
		uploadConfig() {
			let uploadConfig = {
				data: {},
				host: "",
				dir: "",
			};
			let data = this.picSign;
			uploadConfig.host = data.host;
			uploadConfig.data.policy = data.policy;
			uploadConfig.data.signature = data.signature;
			uploadConfig.data.OSSAccessKeyId = data.accessid;
			uploadConfig.data.success_action_status = 201;

			let dir = this.fieldInfo.dir + "/";
			if (this.fieldInfo.dir_type == "_id") {
				dir += this.recordId + "/";
			} else if (this.fieldInfo.dir_type == "date") {
				let date = new Date();
				let y = date.getFullYear();
				let m = date.getMonth() + 1;
				let d = date.getDate();
				dir += this.recordId + "/" + y + "/" + m + "/" + d + "/";
			}
			dir += this.fieldInfo.name + "/";

			uploadConfig.dir = data.dir + dir;
			return uploadConfig;
		},
	},
	created() {},
	mounted() {
		this.getPicSign();
		if (this.timeountHandler) {
			clearInterval(this.timeountHandler);
		}
		//随机刷阿里云签名认证，防止一堆组件同时刷发起多个请求
		this.timeountHandler = setInterval(() => {
			this.getPicSign();
		}, Math.random() * 100000 + 3600000);
	},
	beforeDestroy() {
		if (this.timeountHandler) {
			clearInterval(this.timeountHandler);
		}
	},
	methods: {
		...mapMutations(["getPicSign"]),

		handleExceed() {
			this.$message({
				type: "error",
				message: "只能上传" + MAX_PICS_COUNT + "张图片",
			});
		},
		handlerReOrder(index, direction) {
			if (direction == -1 && index == 0) {
				return;
			}
			if (direction == 1 && index == this.myValue.length - 1) {
				return;
			}
			const tempOption = this.myValue[index + direction];
			this.$set(this.myValue, index + direction, this.myValue[index]);
			this.$set(this.myValue, index, tempOption);
			this.$emit("input", this.myValue);
			this.$emit("change", this.myValue);
		},
		handleRemovePic(index) {
			const v = this.myValue;
			v.splice(index, 1);
			this.myValue = v;
		},
		selectFile(e) {
			if (this.myValue.length + e.target.files.length > MAX_PICS_COUNT) {
				this.handleExceed();
				return;
			}
			this.uploadCounter = e.target.files.length;

			for (let i = 0; i < e.target.files.length; i++) {
				setTimeout(() => {
					this.pushFile(e.target.files[i]);
				}, i * 100);
			}
		},
		pushFile(file) {
			this.loadings.upload = true;
			client
				.put(this.uploadConfig.dir + file.name, file)
				.then(result => {
					const v = this.myValue;
					v.push(result.url.replace(url_replace[0],url_replace[1]));
					this.myValue = v;
					this.uploadCounter--;
					if (this.uploadCounter <= 0) {
						this.loadings.upload = false;
					}
				})
				.catch(err => {
					console.error(err);
					this.uploadCounter--;
					if (this.uploadCounter <= 0) {
						this.loadings.upload = false;
					}
				});
		},
	},
};
</script>
<style lang="scss" >
.picture-card {
	position: relative;
}
.op-btns {
	position: absolute;
	top: 10px;
	right: 20px;
}
.upload-fields {
	width: 100%;
	display: flex;

	.el-upload-list--picture-card {
		display: block;
	}
	.el-upload-list--picture-card .el-upload-list__item {
		width: 180px;
		height: 240px;
	}
	.el-upload--picture-card {
		width: 180px;
		height: 240px;
		border: none;
	}

	.el-upload-dragger {
		width: 180px;
		height: 240px;
	}
	&.disabled {
		.el-upload {
			display: none;
		}
	}
}
</style>
